/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ComponentsFactComponent } from './ComponentsFactComponent'
export type SectionsFactsComponent = {
  id?: number
  __component?: string
  title?: string
  content?: string
  direction?: SectionsFactsComponent.direction
  items?: Array<ComponentsFactComponent>
}
export namespace SectionsFactsComponent {
  export enum direction {
    LEFT = 'Left',
    CENTER = 'Center',
    RIGHT = 'Right',
  }
}
